export const loadingNav = (state: any) => state.navProcesses > 0;

export const loading = (state: any) => state.processes > 0;
